// extracted by mini-css-extract-plugin
export default {"companyContainer":"HM-z","companyImage":"IM-z","container":"JM-z","heading":"KM-z","darkText":"LM-z","smallHeading":"MM-z","darkBackground":"NM-z","whiteBackground":"OM-z"};